<template>
	<JBox class="s-bg-white s-border-gray-300 s-border s-px-4 s-pb-4 s-rounded">
		<slot />

		<JBox v-for="(item, index) in values" :key="index" class="s-mt-4">
			<p class="s-mb-1">{{ item.var }}</p>
			<JBox class="s-cursor-pointer s-w-full s-p-2 s-border s-rounded s-border-gray-300">
				<span>{{ item.valueJsonString || "---" }}</span>
			</JBox>
		</JBox>
	</JBox>
</template>

<script>
export default {
	props: {
		// value returned from renderFunctionTemplate
		values: {
			type: Array
		}
	},

	data() {
		return {
			results: null
		}
	}
}
</script>
